export default __webpack_public_path__ + "static/media/strategy1.000f5b3f.png";